@if (state.panelOpen()) {
  @if (isDesktop()) {
    <ng-container [ngTemplateOutlet]="panelTpl" />
  } @else {
    <nz-drawer
      [nzVisible]="true"
      nzPlacement="bottom"
      [nzClosable]="false"
      [nzHeight]="'auto'"
      nzWrapClassName="notifications-drawer"
      (nzOnClose)="state.closePanel()">
      <ng-container *nzDrawerContent>
        <ng-container [ngTemplateOutlet]="panelTpl" />
      </ng-container>
    </nz-drawer>
  }
}

<ng-template #panelTpl>
  <lkt-notification-panel
    #panelRef
    class="notifications-panel"
    [class.notifications-panel--floating]="isDesktop()"
    [view]="state.view()"
    [filter]="state.filter()"
    (filterChange)="onFilterChange($event)"
    [ignoreElement]="state.anchor()"
    [showMarkAllRead]="state.view() === 'list'"
    (markAllRead)="state.markAllRead()"
    (preferencesOpen)="onPreferencesOpen()"
    (backToList)="state.showList()"
    (closeRequest)="onCloseRequest($event)"
    dataCy="notifications-panel">
    @if (state.view() === "list") {
      @if (showError()) {
        <!--
          Achado 2 (Important, fix round final): uma falha de carga não pode se apresentar como
          "nenhuma notificação" — o único lugar da interface que mentiria. Substitui a lista (que
          pode estar com conteúdo obsoleto de antes da falha) por uma cópia que nomeia o erro e
          oferece tentar de novo, não texto que afirme ausência.
        -->
        <lkt-notification-empty
          [title]="errorTitle"
          [description]="errorDescription"
          actionLabel="Tentar novamente"
          (action)="onRetryLoad()"
          dataCy="notifications-error" />
      } @else {
        @for (item of viewItems(); track item.id) {
          <lkt-notification-item
            [item]="item"
            [dataCy]="itemDataCy(item.id)"
            (select)="onItemSelect(item.id)"
            (ctaSelect)="onCtaSelect(item.id)" />
        }

        @if (showEmpty()) {
          <lkt-notification-empty
            [title]="emptyTitle()"
            [description]="emptyDescription()"
            dataCy="notifications-empty" />
        }

        @if (state.hasMore()) {
          <div
            class="notifications-panel__sentinel"
            aria-hidden="true"
            data-cy="notifications-load-more-sentinel"
            lktInfiniteScroll
            [disabled]="state.loadingMore()"
            (scrolled)="state.loadMore()"></div>
        }
      }
    } @else {
      <lkt-notification-preferences
        [groups]="preferenceRows()"
        [criticalAlerts]="criticalAlertRows()"
        [hasError]="state.preferencesStatus() === 'error'"
        [isReady]="state.preferencesStatus() === 'ready'"
        (toggle)="onPreferenceToggle($event)"
        (retry)="onRetryPreferences()"
        dataCy="notifications-preferences" />
    }
  </lkt-notification-panel>
</ng-template>
